// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--4-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/resolve-url-loader/index.js??ref--4-2!../../node_modules/postcss-loader/dist/cjs.js??ref--4-3!../../node_modules/sass-loader/dist/cjs.js??ref--4-4!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarLayout.vue?vue&type=style&index=1&id=7a055cfc&prod&lang=scss&scoped=true");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("0638f624", content, true, {});